import Home from "./pages/index";
// import ContactPage from "./pages/contact";

function App() {
  return (
    <div className="relative bg-neutral-50 font-roboto text-neutral-700 transition-colors duration-150 dark:bg-neutral-900 dark:text-neutral-200">
      <Home />
    </div>
  );
}

export default App;
